import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/drivers'

export default {
  async getAll(filter) {
    return await axios
      .get(`${endpoint}/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getById(id) {
    return await axios
      .get(`${endpoint}/item/id/${id}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async getCommon() {
    return await axios
      .get(`${endpoint}/common`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async syncAuth(request) {
    return await axios
      .put(`${endpoint}/sync`, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async reactivate(request) {
    return await axios
      .put(`${endpoint}/reactivate`, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async deactivate(request) {
    return await axios
      .put(`${endpoint}/deactivate`, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async uploadImage(request) {
    return await axios
      .post(endpoint + '/image', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/driver/driverService.js